import { TimeRequestDateTimes } from "utils/interfaces"

export function getValidateRequestTimeSelector(requestTimesSelectors: TimeRequestDateTimes[]) {
    const count = requestTimesSelectors.reduce((acc, item) => {
        if (item.date && item.time) {
            return acc + 1
        }
        return acc
    }, 0)

    return requestTimesSelectors.length === count
}
